var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H16H15V3C15 1.35 13.65 0 12 0C10.35 0 9 1.35 9 3V4H8H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM11 3C11 2.45 11.45 2 12 2C12.55 2 13 2.45 13 3C13 3.55 12.55 4 12 4C11.45 4 11 3.55 11 3ZM14 6V7H10V6H14ZM19 20H5V6H8V7C8 8.1 8.9 9 10 9H14C15.1 9 16 8.1 16 7V6H19V20Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H9C8.45 11 8 11.45 8 12C8 12.55 8.45 13 9 13H15C15.55 13 16 12.55 16 12C16 11.45 15.55 11 15 11Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H9C8.45 15 8 15.45 8 16C8 16.55 8.45 17 9 17H15C15.55 17 16 16.55 16 16C16 15.45 15.55 15 15 15Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/Activities.733ea99465356697ff7c248fb1c0254f.svg";
export { ForwardRef as ReactComponent };